export const CANDIDATE_DETAILS_ES = {
  chat: {
    header: 'Déjanos tu feedback',
    toggleButton: 'Escribir a {{ managerName }}',
    toggleButton_open: '$t(candidateDetails.chat.header)',
    toggleCloseHint: 'Cerrar',
    fullScreenButton: 'Pantalla completa',
    sendButtonAriaLabel: 'Enviar',
    message: {
      heading:
        '{{ authorFullName }} - $t(common.formatting.date.dateFormat) horas $t(common.formatting.date.dateFormat_time)',
      defaultMessageFeedback:
        'Hola, {{ name }}. Si deseas compartir algo con nosotros, utiliza este chat.',
      defaultMessageFeedback_positive:
        'Hola {{ name }}. ¿Por qué <strong>te interesa</strong>? En la entrevista, ¿deseas profundizar en algún aspecto?',
      defaultMessageFeedback_negative:
        'Hola, {{ name }}. Introduce tus motivaciones para que podamos perfeccionar la búsqueda de candidatos.',
    },
  },
  dossier: {
    title: 'Summary & CV',
    subtitle: 'Entrevista de trabajo',
    button: 'Descargar dossier',
    showCurriculumButton: 'Ver CV',
    modalTitle:
      '{{ candidateFullName }} | $t(candidate.sections.curriculum.title)',
    modalCloseButtonAriaLabel: 'Cerrar',
  },
  feedback: {
    bubble:
      '¿Te gustaría conocer mejor a {{ candidateFullName }} con una <strong>entrevista</strong>?',
    bubble_interested: '<strong>{{ candidateFullName }}</strong> le interesa',
    bubble_notInterested:
      '<strong>{{ candidateFullName }}</strong> no le interesa',
    bubble_discarded: '<strong>{{ candidateFullName }}</strong> no continúa.',
    actionYes: 'Sí',
    actionNo: 'No',
    actionChangeFeedback: '¿Cambiaste de opinión?',
    interesting: 'Es interesante',
  },
  info: {
    age: '{{ age }} anni',
    drivingTime: {
      hours: '<strong>{{ hours }}</strong>h',
      minutes: '<strong>{{ minutes }}</strong>min',
    },
  },
  intro: {
    editLink: 'Modificar candidatura',
  },
  negativeFeedback: {
    title: '¿Por qué no es interesante?',
    subtitle:
      'Saber por qué no consideras adecuado a este candidato para el puesto (por ejemplo, habilidades, antigüedad, etc.) nos ayuda a presentar solo candidatos perfectamente alineados con tus expectativas.',
    notesLabel: 'Escribe la motivación',
    notesPlaceholder:
      'La motivación se enviará al Head Hunter que sigue la selección.',
    submit: 'Enviar',
    cancel: 'Cancelar',
    successTitle: 'Mensaje enviado:',
    successSubtitle:
      'Hemos enviado tu evaluación al Head Hunter que sigue la búsqueda.',
    successClose: 'Vale, gracias.',
  },
  scout: {
    accordionOpen: 'Abrir',
    accordionClose: 'cerca',
    title: 'Informe del Scout',
    accordionTitle_skillsAssessment: 'Evaluación de habilidades',
    accordionTitle_overallAssessment: 'Resumen de roles',
    button: 'Descargar informe',
  },
};
